const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function trimText(value) {
    return String(value ?? "").trim();
}

/** Format check only when email is filled (email itself is optional). */
export function validateContactEmail(value) {
    const trimmed = trimText(value);
    if (!trimmed) {
        return null;
    }
    if (!EMAIL_PATTERN.test(trimmed)) {
        return "Enter a valid email address";
    }
    return null;
}

/** At least one of email, mobile, or location phone. */
export function validateContactReachability(form) {
    const email = trimText(form?.emailadres);
    const mobile = trimText(form?.telephone_mobile);
    const locationPhone = trimText(form?.telephone_location);
    if (email || mobile || locationPhone) {
        return null;
    }
    return "Enter an email or a phone number";
}

/** @returns {string | null} English error message, or null when valid. */
export function validateContactLocationIds(value) {
    if (!Array.isArray(value) || value.length === 0) {
        return "Select at least one location";
    }
    return null;
}

/** Pure validation for unit tests and Element UI custom validators. */
export function contactFormHasValidationErrors(form) {
    return (
        validateContactEmail(form?.emailadres) !== null ||
        validateContactReachability(form) !== null ||
        validateContactLocationIds(form?.locationIds) !== null
    );
}

/**
 * @param {() => object} getForm current form values (needed for email-or-phone check)
 */
export function buildContactFormRules(getForm = () => ({})) {
    return {
        emailadres: [
            {
                validator: (_rule, value, callback) => {
                    const formatMessage = validateContactEmail(value);
                    if (formatMessage) {
                        callback(new Error(formatMessage));
                        return;
                    }
                    const reachMessage = validateContactReachability(getForm());
                    callback(reachMessage ? new Error(reachMessage) : undefined);
                },
                trigger: ["blur", "change"],
            },
        ],
        locationIds: [
            {
                validator: (_rule, value, callback) => {
                    const message = validateContactLocationIds(value);
                    callback(message ? new Error(message) : undefined);
                },
                trigger: "change",
            },
        ],
    };
}
